export default __webpack_public_path__ + "static/media/icon1.e7ad3ad8.png";